import axios from "axios";
import {baseURL} from "../baseURL";
import Cookies from "js-cookie";

export const getClientsWithoutWhatsapp = (page) => {
    return axios.get(`${baseURL}whatsapp/logs`, {
        params: {
            page,
        },
        headers: {
            Authorization: `Bearer ${Cookies.get('token')}`,
        },
    });
}

export const postClientWithoutWhatsapp = (phone) => {
    return axios.post(
        `${baseURL}whatsapp/logs`,
        null,
        {
            params: {
                phone,
            },
            headers: {
                Authorization: `Bearer ${Cookies.get('token')}`,
            },
        }
    );
};
